/**
 * index
 */
export * from './src/index';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-base/index.js
// module id = 2
// module chunks = 0